module.exports = __webpack_public_path__ + "static/datatable-chart-do-c5dfbe2c88b3eef024434dbe9169682f.png";